import React from 'react';
import { useTranslation } from 'react-i18next';
import { TextInput } from '../../../components/textInput/textInput';
import { OptionsProps } from './completeIncident.interface';

interface OtherProps {
  name: string;
  val: string;
  setData: any;
}

export const CompleteIncidentOther = ({ name, val, setData }: OtherProps) => {
  const { t } = useTranslation();
  return (
    <>
      <TextInput
        type="text"
        name={name}
        value={val}
        label={t('incident.OPTION_LIST_UNDEFINED_OPTION')}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          const { value } = e.target;
          setData((values: OptionsProps) => ({
            ...values,
            [name]: value,
          }));
        }}
      />
    </>
  );
};
